import type { EventSummary as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as SeatingChartSummary from '../SeatingChart/SeatingChartSummary';
import * as VenueRoom from '../Venue/VenueRoom';
import * as VenueSummary from '../Venue/VenueSummary';
import * as EventAnnounceSummary from './EventAnnounceSummary';
import * as EventGroup from './EventGroup';
import * as EventSales from './EventSales';
import { EventState } from './EventState';

export type { EventAnnounceSummary } from './EventAnnounceSummary';

export type EventSummary = {
  id: number;
  name: string;
  slug: string;
  date: string;
  startTime?: string;
  doorTime?: string;
  endTime?: string;
  timezone?: string;
  state: EventState;
  ticketed: boolean;
  holdPreference: number;
  description?: string;
  footerContent?: string;
  minimumAge?: number;
  ticketsUrl?: string;
  /** Event-level totals. The AppSchema calls these `ticketTotals`; `ticketSales` there is the per-blueprint breakdown. */
  ticketSales: EventSales.EventSales;
  venue?: VenueSummary.VenueSummary;
  venueRoom?: VenueRoom.VenueRoom;
  eventGroup?: EventGroup.EventGroup;
  seatingChart?: SeatingChartSummary.SeatingChartSummary;
  announceDetail?: EventAnnounceSummary.EventAnnounceSummary;
};

export const fromGql = (item: GQLItem): EventSummary => ({
  ...take<EventSummary>(
    item,
    'id',
    'name',
    'slug',
    'date',
    'startTime',
    'doorTime',
    'endTime',
    'timezone',
    'state',
    'description',
    'footerContent',
    'minimumAge',
    'ticketsUrl',
  ),
  ticketed: item.ticketed ?? false,
  holdPreference: item.holdPreference ?? 0,
  ticketSales: item.ticketTotals ? EventSales.fromGql(item.ticketTotals) : EventSales.getNew(),
  venue: item.venue ? VenueSummary.fromGql(item.venue) : undefined,
  venueRoom: item.venueRoom ? VenueRoom.fromGql(item.venueRoom) : undefined,
  eventGroup: item.eventGroup ? EventGroup.fromGql(item.eventGroup) : undefined,
  seatingChart: item.seatingChart ? SeatingChartSummary.fromGql(item.seatingChart) : undefined,
  announceDetail: item.announceDetail ? EventAnnounceSummary.fromGql(item.announceDetail) : undefined,
});
